import { createInertiaApp } from '@inertiajs/react'
import { StrictMode, createElement, type ComponentType } from 'react'
import { createRoot } from 'react-dom/client'

// Map every page module so we can resolve both the
// `pages/Name/index.tsx` (our convention) and flat `pages/Name.tsx` forms.
const pages = import.meta.glob<{ default: ComponentType }>('../pages/**/*.tsx')

void createInertiaApp({
  resolve: async (name) => {
    const importer =
      pages[`../pages/${name}/index.tsx`] ?? pages[`../pages/${name}.tsx`]
    if (!importer) {
      throw new Error(`Page not found: ${name}`)
    }
    return (await importer()).default
  },

  setup({ el, App, props }) {
    createRoot(el).render(createElement(StrictMode, null, createElement(App, props)))
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
